import { Component } from '@angular/core';
import * as moment from 'moment';
import { ResourceService, NavigationService, AlertService, UserService } from 'sce-core';
import { LeftPanelService, DatePickerConfigService } from 'sce-ui-lib';
import { AbstractFormWidgetComponent } from '../../../../../shared/components/widget/abstract-form-widget/abstract-form-widget.component';
import { DockDoorBookingActionService } from '../services/dock-door-booking-action.service';
import { DockDoorBookingDataEditorService } from '../services/dock-door-booking-data-editor.service';
import { DockDoorBookingDataService } from '../services/dock-door-booking-data.service';

@Component({
  selector: 'lfwms-dock-door-booking-primary-accordian',
  templateUrl: './dock-door-booking-primary-accordian.component.html',
  styleUrls: ['./dock-door-booking-primary-accordian.component.css']
})
export class DockDoorBookingPrimaryAccordianComponent extends AbstractFormWidgetComponent {

  public dataService: DockDoorBookingDataService;
  public dataEditor: DockDoorBookingDataEditorService;
  private tableId:any = this.actionService.tableIds;

  constructor(protected resourceService: ResourceService,
    protected navService: NavigationService,
    protected leftPanelService: LeftPanelService,
    protected alertService: AlertService,
    protected userService: UserService,
    protected actionService:DockDoorBookingActionService,
    protected dateConfigService: DatePickerConfigService) {
    super(resourceService, navService, leftPanelService,
      alertService, userService, dateConfigService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    if (this.dataService.displayMode === 'C' && this.dataService.selectedCellData) {
      this.cellDataMap['facility'].cVal = this.dataService.selectedCellData.facility;
      this.cellDataMap['fromDoor'].cVal = this.dataService.selectedCellData.fromDoor;
      this.cellDataMap['bookingDate'].cVal = new Date(this.dataService.selectedCellData.date);
      this.cellDataMap['bookingDate'].cVal = moment(this.cellDataMap['bookingDate'].cVal).format('YYYY-MM-DD') + ' ' +this.dataService.selectedCellData.bookingTimefr;
      this.cellDataMap['fromBookingTime'].cVal = this.dataService.selectedCellData.bookingTimefr;
      // if(this.tableId === 'ddbooktd')
      //   this.cellDataMap['bookingTime'].cVal = this.dataService.selectedCellData.bookingTimeto;
    } 
    if (this.dataService.displayMode === 'C' && this.dataService.selectedCellData && this.tableId === 'ddbooktd') {
      this.cellDataMap['toDoor'].cVal = this.dataService.selectedCellData.toDoor;
      this.dataEditor.populateCallTime();
    } 
    if (this.dataService.displayMode === 'C' && this.dataService.selectedCellData && (this.tableId === 'ddbooktd' || this.tableId === 'ddbookintd')) {
      this.cellDataMap['fromBookingTime'].cVal = this.dataService.selectedCellData.bookingTimefr;
      this.cellDataMap['bookingTime'].cVal = moment(this.cellDataMap['bookingDate'].cVal).format('YYYY-MM-DD') + ' ' +this.dataService.selectedCellData.bookingTimeto;
    } else {
      if (this.tableId !== 'ddbookintd' && this.cellDataMap['fromBookingTime'].cVal) {
        let time = moment(this.cellDataMap['fromBookingTime'].cVal);
        this.cellDataMap['fromBookingTime'].cVal = time.format('HH:mm');
      }
      if (this.tableId !== 'ddbookintd' && this.cellDataMap['bookingTime'] && this.cellDataMap['bookingTime'].cVal) {
        let time = moment(this.cellDataMap['bookingTime'].cVal);
        // if(this.tableId === 'ddbooktd')
        //   this.cellDataMap['bookingTime'].cVal = time.format('HH:mm');
      }
      if (this.tableId == 'ddbookintd' && this.cellDataMap['bookingDate'].cVal && this.cellDataMap['fromBookingTime'].cVal) {
        let time = moment(this.cellDataMap['fromBookingTime'].cVal);
        let completeTime = time.format('HH:mm:ss.SSS');
        if(this.cellDataMap['fromBookingTime'].cVal != this.cellDataMap['bookingDate'].cVal)
         this.cellDataMap['bookingDate'].cVal = this.cellDataMap['bookingDate'].cVal+ " " + completeTime;
      }
    }
    this.dataEditor.populateDoorValuesBasedOnFacilityInAccordion();
  }

  public realignWidget(): void {
    let cellsPerRow: number = 0;
    this.windowWidth = window.innerWidth - this.sidePanelWidth;

    switch (true) {
      case (this.windowWidth > 1250): {
        cellsPerRow = 5;
        break;
      }
      case (this.windowWidth <= 1250 && this.windowWidth > 1030): {
        cellsPerRow = 4;
        break;
      }
      case (this.windowWidth <= 1030 && this.windowWidth >= 800): {
        cellsPerRow = 3;
        break;
      }
      case (this.windowWidth <= 800 && this.windowWidth >= 560): {
        cellsPerRow = 2;
        break;
      }
      case (this.windowWidth < 560): {
        cellsPerRow = 1;
        break;
      }
      default: {
        cellsPerRow = 5;
        break;
      }
    }
    const newPropertyList = this.removeHiddenFields();
    this.propertyList = this.preparePropertyGrid(newPropertyList, cellsPerRow);
  }

  public removeHiddenFields() {
    const propertyListArray = this.widgetConfig.propertyList;
    const newPropertyListArray = [];
    for (let i = 0; i < propertyListArray.length; i++) {
      if (this.metadataMap[propertyListArray[i]]['displayType'] !== 'H') {
        newPropertyListArray.push(propertyListArray[i]);
      }
    }
    return newPropertyListArray;
  }

  // Method to define grid layout for each accordion.
  private preparePropertyGrid(propertyList: Array<any>, cellsPerRow) {
    let accordionRow;
    const accordionDefinition = [];
    for (let x = 0; x < propertyList.length; x++) {
      if (x % cellsPerRow === 0) {
        if (accordionRow && accordionRow.length === cellsPerRow) {
          accordionDefinition.push(accordionRow);
        }
        accordionRow = [];
      }
      accordionRow.push(propertyList[x]);
    }
    if (accordionRow && accordionRow.length !== 0) {
      for (let y = accordionRow.length; y < cellsPerRow; y++) {
        accordionRow.push('dummy');
      }
      accordionDefinition.push(accordionRow);
    }
    return accordionDefinition;
  }

  // public getCellDisplayValue(property: any): any {
  //   if (property === 'duration') {
  //     let fromBookingTime = this.cellDataMap['fromBookingTime'].cVal;
  //     let bookingTime = this.cellDataMap['bookingTime'].cVal;
  //     if (!fromBookingTime || !bookingTime) {
  //       return '-';
  //     }
  //     fromBookingTime = fromBookingTime.split(':');
  //     bookingTime = bookingTime.split(':');
  //     let h = +bookingTime[0] - fromBookingTime[0];
  //     let m = +bookingTime[1] - fromBookingTime[1];
  //     if (m < 0) {
  //       h--;
  //       m = 60 + m;
  //     }
  //     let hstr = '';
  //     if (h > 0) {
  //       hstr = `${h.toString().padStart(2, '0')}hr${h > 1 ? 's' : ''}`;
  //     }
  //     return `${hstr}${m.toString().padStart(2, '0')}min${m > 1 ? 's' : ''}`;
  //   }else if(property==='callTime'){
  //     const callTime = this.cellDataMap['callTime'].cVal;
  //     if(!callTime){
  //       return '00:00';
  //     }
  //     return moment(callTime).format('HH:mm');
  //   }
  //   return super.getCellDisplayValue(property);
  // }

    public getCellDisplayValue(property: any): any {
      if (property === 'duration') {
        //LFWM-4874-change in logic to get hours diff between 2 dates for duration field
        let fromBookingTime = this.cellDataMap['bookingDate'].cVal;
        let bookingTime = this.cellDataMap['bookingTime'].cVal;
        if (!fromBookingTime || !bookingTime) {
          return '-';
        }
        if (fromBookingTime && bookingTime) {
          const dateOneObj: any = new Date(bookingTime);
          const dateTwoObj: any = new Date(fromBookingTime);
          const milliseconds = Math.abs(dateTwoObj - dateOneObj);
          const hours = milliseconds / 36e5;
  
          const seconds = (milliseconds / 1000) % 60;
          const minutes = ((milliseconds / (1000 * 60)) % 60);
          const hourss = ((milliseconds / (1000 * 60 * 60)));

          // const momentOne = moment(bookingTime);
          // const momentTwo = moment(fromBookingTime);
          // const durationA = moment.duration(momentOne.diff(momentTwo));
          // let hourDiff = durationA.hours();
          // let minutesDiff = durationA.minutes();
          // let daysDiff = durationA.days();
          // let secDiff = durationA.seconds();

          // if(hourDiff == 0 && daysDiff > 0)
          //   hourDiff = daysDiff * 24;
          // if(hourDiff > 0 && daysDiff > 0)
          //   hourDiff = ((daysDiff * 24)-hourDiff);
  
          this.actionService.finalDuration = '1900-01-01' + ' ' + hourss + ':' + minutes + ':' + seconds + '.' + '000';
          return `${hourss.toString().split('.')[0]}hr${minutes}min`;
        }
      } else if (property === 'callTime') {
        const callTime = this.cellDataMap['callTime'].cVal;
        if (!callTime) {
          return '00:00';
        }
        return moment(callTime).format('HH:mm');
      }
      return super.getCellDisplayValue(property);
    }
  
  public valueChanged(key: any, sourceEvent?: any): void {
    if (key === 'facility') {
      this.dataEditor.populateCallTime();
      this.dataEditor.populateDoorValuesBasedOnFacilityInAccordion();
    } else if ((key === 'bookingDate' || key === 'fromBookingTime') && this.tableId === 'ddbooktd') {
      this.dataEditor.populateCallTime();
    }
    //LFWM-4874- adding date validation
    if (key == "bookingDate" || key == "bookingTime"){
      this.actionService.validBookingDt = true;
      let fromBookingTime;
      let bookingTime;
      if (key == "bookingDate") {
        fromBookingTime = new Date(sourceEvent);
      } else {
        fromBookingTime = new Date(this.cellDataMap['bookingDate'].cVal);
      }
      if (key == "bookingTime") {
        bookingTime = new Date(sourceEvent);
      } else {
        bookingTime = new Date(this.cellDataMap['bookingTime'].cVal);
      }
      if (fromBookingTime && bookingTime && typeof (fromBookingTime) == "object" && typeof (bookingTime) == "object") {
        this.actionService.validBookingDt = true;
        if (bookingTime < fromBookingTime) {
          this.actionService.validBookingDt = false;
          this.alertService.error('Booking Start Date should be greater than Booking End Date');
          return;
        }
      }
    }
    super.valueChanged(key, sourceEvent);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/dock-door-booking/dock-door-booking-home/dock-door-booking-primary-accordian/dock-door-booking-primary-accordian.component.ts